// enum EventTypes {
//   PURCHASE = 'purchase',
// }

// export type EventPurchasePayloadType = {
//   currency: 'CAD'
//   transation_id: number
//   value: number
//   items: [
//     {
//       item_id: string
//       locale: string
//       item_category: string
//       price: number | 'not set'
//       provider?: string
//       planInfo?: Record<string, unknown>
//     },
//   ]
// }

export const sendGA4Event = (eventType: string, eventPayload: Record<string, unknown>) => {
  window.gtagPlanhub('event', eventType, eventPayload)
}

export const sendGenerateLeadEvent = (eventPayload: Record<string, unknown>) => {
  sendGA4Event('generate_lead', eventPayload)
}

export const setDefaultConsent = () => {
  window.gtagPlanhub('consent', 'default', {
    ad_storage: 'granted',
    analytics_storage: 'granted',
    functionality_storage: 'granted',
    personalization_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 2000,
  })
  window.gtagPlanhub('set', 'ads_data_redaction', true)
  window.gtagPlanhub('set', 'url_passthrough', true)
}
